export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Quali classi copre Matematica Pronta?',
    answer:
      'Dieci anni scolastici completi: le cinque classi della primaria, le tre della secondaria di primo grado e i due anni del biennio delle superiori. Ogni volume corrisponde a un anno.',
  },
  {
    question: 'È allineato al curricolo italiano?',
    answer:
      'Sì. Ogni volume segue i traguardi delle Indicazioni Nazionali del MIUR per il proprio anno: numeri e algebra, spazio e figure, relazioni e funzioni, dati e previsioni.',
  },
  {
    question: 'In che formato sono i volumi?',
    answer:
      'PDF in A4 a 300 DPI, pronti per la stampa professionale e perfettamente leggibili da tablet, computer o LIM.',
  },
  {
    question: "Come lo ricevo dopo l'acquisto?",
    answer: "Subito. Ricevi un'email con i link per scaricare tutti i file: l'accesso è immediato e permanente.",
  },
  {
    question: 'Posso usarlo per una classe intera o per più classi?',
    answer:
      'Sì. Puoi stampare e utilizzare il materiale per tutte le tue classi, anche negli anni successivi, senza limiti.',
  },
  {
    question: 'Serve una preparazione specifica in matematica per usarlo?',
    answer:
      'No. Ogni lezione include le indicazioni passo passo su cosa dire e cosa mostrare, con tutti i passaggi già svolti.',
  },
  {
    question: 'Esiste una politica di rimborso?',
    answer:
      'Sì. Hai 30 giorni per provarlo: se non fa al caso tuo ti rimborsiamo per intero e tieni comunque i file.',
  },
]
